import { Container, Modal, ProgressBar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import check_icon_circle from "../../../assets/images/check-icon-circle.svg";
import warning_icon from "../../../assets/images/warning-icon-red.svg";
import { useEffect } from "react";

export function ModalConfirmarCreacion(props) {
  const { show, code, message, onHide } = props;
  const { t } = useTranslation();

  // Simulamos una barra de progreso que va disminuyendo en 5 segundos
  useEffect(() => {
    if (show) {
      const progressBar = document.querySelector(".progress-bar");
      let width = 100;
      const interval = setInterval(() => {
        if (width <= 0) {
          clearInterval(interval);
          // onHide({ show: false });
        } else {
          width--;
          progressBar.style.width = width + "%";
        }
      }, 20); // Para 2 segundos de duración (100 pasos de 1%), el intervalo es 20ms.

      return () => clearInterval(interval);
    }
  }, [onHide]);

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={() => onHide({ show: false })}
    >
      <Container className="py-2">
        <Modal.Body>
          <div className="d-flex justify-content-center">
            {code === 201 ? (
              <img
                src={check_icon_circle}
                alt="check"
                className="mb-3 mx-auto"
              />
            ) : code === 206 ? (
              <img src={warning_icon} alt="check" className="mb-3 mx-auto" />
            ) : (
              <img
                src={check_icon_circle}
                alt="check"
                className="mb-3 mx-auto"
              />
            )}
          </div>
          <h5 className="text-center mt-2">
            {message !== "" && message !== undefined && message !== null
              ? message
              : t("flotas.importar-vehiculos.modal-confirmar-creacion.title")}
          </h5>
        </Modal.Body>
        {/* Añadimos una barra de progreso que va disminuyendo en 5 segundos */}
        <span>
          <ProgressBar variant="danger" now={100} style={{ height: "5px" }} />
        </span>
      </Container>
    </Modal>
  );
}
